import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@app/environment/environment';
import {
  VeriffSessionRequest,
  VeriffSessionResponse,
  VeriffStatusResponse,
} from '@app/models/veriff.models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VeriffService {
  private readonly API_URL = environment.apiUrl;
  private http = inject(HttpClient);

  createSession(redirectURL: string): Observable<VeriffSessionResponse> {
    const body: VeriffSessionRequest = { redirectURL };
    return this.http.post<VeriffSessionResponse>(
      `${this.API_URL}/Veriff/Session`,
      null,
    );
  }

  getStatus(): Observable<VeriffStatusResponse> {
    return this.http.get<VeriffStatusResponse>(`${this.API_URL}/Veriff/Status`);
  }
}
